export default "__VITE_ASSET__BlJTAqmd__"